import { formatToBRL, Tag, Text } from 'components/InterUI/InterUI'
import { convertYearMonthDayToString } from 'utils/commons'
import { rafflesEnum } from 'common/enums/AfterSales'
import RafflePngs from 'assets/png'

import * as S from './RaffleCard.styles'
import { IRaffle } from '../RafflesCarousel.types'

interface IRaffleCardProps {
  raffle: IRaffle
  handleCardDetails: (raffle: IRaffle) => void
}

export const RaffleCard = ({ raffle, handleCardDetails }: IRaffleCardProps) => {
  const bgColorCard =
    raffle.status === rafflesEnum.WIN && !raffle.paymentDate
      ? 'var(--primary100)'
      : 'var(--gray100)'
  const giftColor =
    raffle.status === rafflesEnum.REALIZED ||
    (raffle.status === rafflesEnum.WIN && Boolean(raffle.paymentDate))

  const getRaffleDetails = (status: rafflesEnum) => {
    const details = {
      [rafflesEnum.WIN]: {
        gift: RafflePngs.raffleWin,
        tag: (
          <S.TagContent>
            <Tag size="small" theme="green">
              Você ganhou
            </Tag>
          </S.TagContent>
        ),
      },
      [rafflesEnum.REALIZED]: {
        gift: RafflePngs.raffleRealized,
        tag: (
          <S.TagContent>
            <Tag size="small" color="var(--gray200)" colorText="var(--gray500)">
              Sorteio Realizado
            </Tag>
          </S.TagContent>
        ),
      },
      [rafflesEnum.NEXT]: {
        gift: RafflePngs.raffleNextSoon,
        tag: (
          <S.TagContent>
            <Tag size="small" theme="yellow">
              Próximo sorteio
            </Tag>
          </S.TagContent>
        ),
      },
      [rafflesEnum.SOON]: {
        gift: RafflePngs.raffleNextSoon,
        tag: (
          <S.TagContent>
            <Tag size="small" theme="gray">
              Em breve
            </Tag>
          </S.TagContent>
        ),
      },
    }

    return details[status]
  }

  const { gift, tag } = getRaffleDetails(raffle.status)

  return (
    <S.RaffleCard
      data-testid={`card-${raffle.raffleId}`}
      key={raffle.raffleId}
      onClick={() => handleCardDetails(raffle)}
    >
      <S.RaffleCardGift $bgColorCard={bgColorCard} $giftColor={giftColor}>
        {raffle.extraChance && (
          <S.ExtraChanceTag>
            <Tag size="small" theme="green">
              Chance extra
            </Tag>
          </S.ExtraChanceTag>
        )}

        {gift}
      </S.RaffleCardGift>
      {tag}

      <S.RaffleCardContent>
        <Text variant="body-3" as="h3" bold colorWeight={500}>
          {raffle.title} <br />
          {formatToBRL(raffle.value)}
        </Text>
        <Text variant="caption-1" as="p">
          {convertYearMonthDayToString(raffle.date)}
        </Text>
      </S.RaffleCardContent>
    </S.RaffleCard>
  )
}
